// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { WeatherTypes } from "./Shared.WeatherTypes.gen";
import { TimeOfDay } from "./Shared.TimeOfDay.gen";
import { SceneType } from "./Shared.SceneType.gen";
import { TargetTypes } from "./Shared.TargetTypes.gen";
import { FHWAClasses } from "./Shared.FHWAClasses.gen";

export interface IPhotoMetaBulkUpdateRequest {
	ids: string[] | undefined;

	weather: WeatherTypes | undefined | number ;

	timeOfDay: TimeOfDay | undefined;

	scene: SceneType | undefined;

	targetTypesInView: TargetTypes | undefined | number ;

	fhwaClassesInView: FHWAClasses | undefined;

	dewarpedImage: boolean | undefined;

	needsReview: boolean | undefined;

	numLanes: number | undefined;

	addedToTrainingDataset: boolean | undefined;

	trainingDatasetName: string | undefined;

	$type?: string | undefined;
}
export class PhotoMetaBulkUpdateRequest {
	constructor(data?: IPhotoMetaBulkUpdateRequest) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	ids: string[] | undefined;

	weather: WeatherTypes | undefined | number ;

	timeOfDay: TimeOfDay | undefined;

	scene: SceneType | undefined;

	targetTypesInView: TargetTypes | undefined | number ;

	fhwaClassesInView: FHWAClasses | undefined;

	dewarpedImage: boolean | undefined;

	needsReview: boolean | undefined;

	numLanes: number | undefined;

	addedToTrainingDataset: boolean | undefined;

	trainingDatasetName: string | undefined;

	static $type: string = "CoreApi.Models.PhotoMetaBulkUpdateRequest, ";
	$type?: string | undefined = PhotoMetaBulkUpdateRequest.$type;
}

